import { Auth0Provider } from '@auth0/auth0-react'
import { equals } from 'ramda'
import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Provider } from 'react-redux'
import { Store } from 'redux'

import { State } from '~redux/store'
import { MaintenanceGate } from '~shared-components/components/Maintenance/MaintenanceGate'
import { isDev, isServer, isTest } from '~shared-components/utils'

import { AllTheTheme } from './AllTheThemes'

const reactQueryClient = new QueryClient()

reactQueryClient.setDefaultOptions({
  queries: {
    cacheTime: 60 * 60 * 1000,
    // Disables the checking if the JSON response is equal, due to the response having looping references -_-;
    // So instead we use our own isDataEqual
    // structuralSharing: false is requried for custom equality
    isDataEqual: (p1: unknown, p2: unknown) => equals(p1, p2),
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
    structuralSharing: false,
  },
})

const AllTheProviders = ({
  children,
  store,
}: {
  children: React.ReactNode
  store: Store<State>
}) => {
  const { auth0Audience, auth0ClientId, auth0Domain } = store.getState().config

  return (
    <Provider store={store}>
      <Auth0Provider
        audience={auth0Audience}
        cacheLocation={isTest() || isDev() ? 'localstorage' : 'memory'}
        clientId={auth0ClientId}
        domain={auth0Domain}
        redirectUri={!isServer() ? window.location.origin : undefined}
      >
        <QueryClientProvider client={reactQueryClient}>
          {!isServer() && !isTest() && (
            <ReactQueryDevtools position="bottom-right" />
          )}
          <AllTheTheme>
            <MaintenanceGate>{children}</MaintenanceGate>
          </AllTheTheme>
        </QueryClientProvider>
      </Auth0Provider>
    </Provider>
  )
}

export default AllTheProviders
